module.exports = __webpack_public_path__ + "assets/images/layers.png";


//////////////////
// WEBPACK FOOTER
// ./~/leaflet/dist/images/layers.png
// module id = 1532
// module chunks = 1